import { useEffect, useState } from 'react';

/**
 * Osobní nastavení navigace rozvozce (2026-10-26).
 *
 * Každý si v ⋯ běžící směny vypne, co ho ruší:
 *   hlas        — mluvená upozornění (stopka, radar, rychlost…),
 *   upozorneni  — upozornění na trase úplně (karta i hlas).
 * Firemní telefony si rozvozci předávají, proto klíč nese ID uživatele
 * (`window.__flUzivatelId` nastavuje app.jsx po přihlášení). Admin
 * vypínač v Správě (DopravniInfo) platí dál pro všechny — tohle jen
 * ubírá, nikdy nepřidá.
 */
export const VYCHOZI = { hlas: true, upozorneni: true };
const UDALOST = 'fl-navigace-osobni';

const klic = () => `fl.navigace.osobni.${window.__flUzivatelId ?? 'host'}`;

export function nactiOsobni() {
    try {
        return { ...VYCHOZI, ...(JSON.parse(localStorage.getItem(klic()) || '{}') || {}) };
    } catch {
        return { ...VYCHOZI };
    }
}

export function ulozOsobni(zmena) {
    const nove = { ...nactiOsobni(), ...zmena };
    try { localStorage.setItem(klic(), JSON.stringify(nove)); } catch { /* bez úložiště jen do zavření */ }
    window.dispatchEvent(new CustomEvent(UDALOST, { detail: nove }));
    return nove;
}

/** Nastavení, které se samo překreslí, když ho člověk změní v ⋯. */
export function useOsobniNavigace() {
    const [n, setN] = useState(nactiOsobni);
    useEffect(() => {
        const zmena = (e) => setN(e.detail ?? nactiOsobni());
        window.addEventListener(UDALOST, zmena);
        return () => window.removeEventListener(UDALOST, zmena);
    }, []);
    return n;
}
